// import './App.css'
import "./css/styles.css"
// import logo from './logo.svg'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { Header, Nav, Sidebar, Footer } from "./components/common"
import Home from "./pages/Home"
import Videos from "./pages/Videos"
import Downloads from "./pages/Downloads"
import Social from "./pages/Social"
import Error404 from "./pages/Error404"

function App() {
  return (
    <Router>
      <Header />
      <Nav />
      
      <Routes>
        <Route path="/" element={<Home title="Least1234" />} />
        <Route path="/videos" element={<Videos title="Least1234 Videos" />} />
        <Route path="/downloads" element={<Downloads title="Least1234 Downloads" />} />
        <Route path="/social" element={<Social title="Least1234 Social" />} />
        <Route path="*" element={<Error404 title="404 - Page not found" />} />
        {/* <Route component={Error404} /> */}
      </Routes>
      
      <Sidebar />
      
      <Footer />
    </Router>
  )
}

export default App
